export default __webpack_public_path__ + "static/media/_DSC0905.4bceb51a.JPG";